/**
 * Sezzle Widget Duplication Fix (Global Page Observer)
 * * WHY: The previous script hooked into the wrong .shopify-app-block (Judge.me).
 * Sezzle blocks load later asynchronously. We now watch the main product area.
 */

console.log("[Sezzle Fix] Script initialized and running.");

// Watch the entire product wrapper (adjust class if your theme uses a different main product container, 'body' is a safe catch-all)
const targetPageContainer = document.querySelector('body');

if (!targetPageContainer) {
//   console.warn("[Sezzle Fix] Could not find page body container.");
} else {
//   console.log("[Sezzle Fix] Watching page for delayed Sezzle injections...");

  const observer = new MutationObserver(() => {
    // 1. Scan the page to see if a Sezzle app block has finally loaded
    // We target IDs starting with 'shopify-block-' but specifically containing the Sezzle render element inside
    const sezzleContainer = document.querySelector('.shopify-app-block #sezzle-widget-v2-render-reference')?.closest('.shopify-app-block');
    
    if (sezzleContainer) {
      // 2. Fetch all instances of the Sezzle info button currently rendered inside it
      const sezzleWidgets = sezzleContainer.querySelectorAll('.sezzle-shopify-info-button');
      
      // 3. If duplicates start appearing, run the cleanup
      if (sezzleWidgets.length > 1) {
        // console.log(`[Sezzle Fix] Duplication caught! Found ${sezzleWidgets.length} Sezzle widgets.`);
        
        let removalCount = 0;
        for (let i = 0; i < sezzleWidgets.length - 1; i++) {
          const legacyAmount = sezzleWidgets[i].querySelector('.sezzle-payment-amount')?.textContent || "Unknown";
        //   console.log(`[Sezzle Fix] Removing stale widget instance #${i + 1} (Amount: ${legacyAmount})`);
          
          sezzleWidgets[i].remove();
          removalCount++;
        }

        const activeAmount = sezzleWidgets[sezzleWidgets.length - 1].querySelector('.sezzle-payment-amount')?.textContent || "Unknown";
        // console.log(`[Sezzle Fix] Cleanup complete. Kept active instance amount: ${activeAmount}`);
      }
    }
  });

  // Monitor everything added anywhere inside the body as things stream in asynchronously
  observer.observe(targetPageContainer, { childList: true, subtree: true });
}